import React from 'react'
import { Col, Form, Row, Select, Input } from 'antd';

export default function PositionFilterForm({
  form,
  filters,
  setFilters,
  orgOptions,
  divOptions,
  deptOptions,           
  setDivOptions,
  setDeptOptions,
  isLoadingOrgList,
  isLoadingDivList,
  isLoadingDeptList,
  fetchDataDivision,
  fetchDataDepartment,
}) {
  return (
    <Form layout="horizontal" form={form}>
      <Row gutter={16}>
         
        <Col xs={24} sm={8} md={6}>
          <Form.Item name="orgId"  label="Filter By">
            <Select
              style={{ width: '100%' }}
              allowClear
              showSearch
              placeholder="Select Organization"
              loading={isLoadingOrgList}
              options={orgOptions}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                setFilters((prev) => ({
                  ...prev,
                  orgId: value || null,
                  divId: null,
                  deptId: null,
                   posId: null,
                }));
                form.setFieldsValue({ divId: undefined, deptId: undefined, posId: undefined });
                if (value) fetchDataDivision(value);
                else setDivOptions([]);
              }}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={8} md={5}>
          <Form.Item name="divId">
            <Select
              style={{ width: '100%' }}
              allowClear
              placeholder="Select Division"
              loading={isLoadingDivList}
              disabled={!filters?.orgId}
              options={divOptions}
              onChange={(value) => {
                setFilters((prev) => ({
                    ...prev,
                    divId: value || null,
                    deptId: null, // reset dept saat division berubah
                }));
                form.setFieldsValue({ deptId: undefined });
                if (value) fetchDataDepartment(value);
                else setDeptOptions([]);
                }}

            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={8} md={5}>
            <Form.Item name="deptId">
                <Select
                style={{ width: '100%' }}
                allowClear
                placeholder="Select Department"
                loading={isLoadingDeptList}
                disabled={!filters?.divId}
                options={deptOptions}
                onChange={(value) => {
                setFilters((prev) => ({
                    ...prev,
                    deptId: value || null,
                    posId: null
                }));
                }}
                />
            </Form.Item>
        </Col>

        {/* <Col xs={24} sm={8} md={4}>
          <Form.Item name="posCode">
            <Input
              allowClear
              placeholder="Search Code"
              value={filters.posCode}
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  posCode: e.target.value,
                }));
              }}
            />
          </Form.Item>
        </Col> */}

        {/* 🔍 Freetext Position Name */}
        <Col xs={24} sm={8} md={4}>
          <Form.Item name="posName">
            <Input
              allowClear
              placeholder="Search Name"
              value={filters.posName}
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  posName: e.target.value,
                }));
              }}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={10} md={4}>
              <Form.Item name='statusFilter'>
                  <Select
                  allowClear
                  placeholder="Select Status"
                  onChange={(value) => {
                      setFilters(prev => ({
                      ...prev,
                      status: value
                      }));
                  }}
                  >
                  <Select.Option value="true">Active</Select.Option>
                  <Select.Option value="false">Inactive</Select.Option>
                  </Select>
              </Form.Item>
          </Col>
        


      </Row>
    </Form>
  );
}
